<template>
  <b-container
    v-if="sectionsData"
  >
    <b-row no-gutters class="card-deck">
      <b-col
        v-for="(section, index) in sectionsData"
        :key="index"
        sm="6"
        lg="4"
        class="cardbox"
      >
        <b-card no-body class="section-card">
          <b-card-img
            :src="section.symbolbild"
            class="card-img-top shadow image-link"
            :alt="section.titel"
            @click="linkImage(section.slug)"
          />
          <b-card-body>
            <b-card-title>{{ section.titel }}</b-card-title>
            <div
              v-html="normalize(section.kurztext)"
              class="card-text"
            />
            <MehrButton
              :linkTo="`/verlag/${section.slug}/${lang}`"
            />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MehrButton from '@/components/subparts/Mehr-button-subpart.vue'

export default {
  name: 'SektionDBRubriken',
  components: {
    MehrButton
  },
  methods: {
    ...mapActions([

    ]),
    linkImage (to) {
      this.$router.push(`/verlag/${to}/${this.lang}`)
    }
  },
  computed: {
    ...mapGetters({
      sectionsData: 'getDLSectionsData',
      lang: 'getLanguage'
    })
  },
  created () {
    if (this.$store.state.dlSectionsData.de === undefined) {
      // this.$store.dispatch('fetchApiDLSectionsData')
    }
  }
}
</script>

<style scoped lang="scss">

</style>
